import { getImagePathWithHash } from '@utils/load_images';
var _HOST_NAME = window.location.hostname;
// Prod hostname should be www.nomnomnow.com or *-dot-nom-nom-now.appspot.com.
var IS_PROD = _HOST_NAME.includes('nomnomnow.com') || _HOST_NAME.includes('nom-nom-now.appspot.com');
var IS_STAGING = _HOST_NAME.includes('nom-nom-dev') || _HOST_NAME.includes('nomstaging.com');
var ADMIN_HOST_NAME = 'http://admin.nomnomnow.local:4004';
var WWW_HOST_NAME = 'http://www.nomnomnow.local:4004';
if (IS_PROD) {
    ADMIN_HOST_NAME = 'https://admin.nomnomnow.com';
    WWW_HOST_NAME = 'https://www.nomnomnow.com';
}
else if (IS_STAGING) {
    ADMIN_HOST_NAME = 'https://admin.nomstaging.com';
    WWW_HOST_NAME = 'https://www.nomstaging.com';
}
var IS_LOCAL = !IS_PROD && !IS_STAGING;
var STRIPE_URL = IS_PROD ? 'https://dashboard.stripe.com/' : 'https://dashboard.stripe.com/test/';
var STRIPE_INVOICE_URL = "".concat(STRIPE_URL, "invoices/");
export var ITERABLE_PROJECT_ID = IS_PROD ? 17917 : 17918;
// Set the favicon to different colors so it's easy to distinguish what
// environment you're in by tab.
if (!IS_PROD) {
    var favicon = document.getElementById('js-favicon');
    if (favicon) {
        if (IS_STAGING) {
            favicon.setAttribute('href', getImagePathWithHash('logo/favicon-staging.png'));
        }
        else {
            favicon.setAttribute('href', getImagePathWithHash('logo/favicon-local.png'));
        }
    }
}
export { ADMIN_HOST_NAME, IS_LOCAL, IS_PROD, IS_STAGING, STRIPE_URL, STRIPE_INVOICE_URL, WWW_HOST_NAME, };
